<template>
  <div class="orderDetail">
    <van-button plain type="primary" class="print_btn" @click="orderPrint">打印</van-button>
    <van-skeleton title v-if="showDetail" :row="12" />
    <div v-else>
      <!-- <div class="gaidan" v-if="detailData.status==4 || detailData.before_sn">
        <div v-if="detailData.status==4" @click="tobefore(detailData.order_sn,1)">查看改单后</div>
        <div v-else @click="tobefore(detailData.before_sn,2)">查看改单前</div>
      </div>-->
      <div class="part part1">
        <div class="title">
          <span>
            订单信息
            <em>（ 日单号: {{detailData.day_num}} ）</em>
          </span>
          <span class style="color:#999" v-if="detailData.status=='0'">未支付</span>
          <span class="green" v-if="detailData.status=='1'">已结清</span>
          <span
            class="red"
            v-if="detailData.status=='2' && detailData.need_repayment_amount == detailData.order_amount"
          >整单赊欠</span>
          <span
            class="red"
            v-if="detailData.status=='2' && detailData.need_repayment_amount != detailData.order_amount"
          >部分赊欠</span>
          <span class="blue" v-if="detailData.status=='3'">作废</span>
          <span class="orange" v-if="detailData.status=='4'">退款</span>
        </div>
        <div class="buyer_name">
          <!-- 买家 -->
          <span class="van-ellipsis" style="width:5rem">{{detailData.buyer_name}}</span>
          <!-- 订单金额 -->
          <span>￥{{detailData.order_amount}}</span>
        </div>
        <div class="text_bw">
          <div class="text">应收：{{detailData.receivables}}元</div>
          <div
            class="text"
            v-if="detailData.discount<0"
          >订单优惠：{{-Number(detailData.discount).toFixed(2)}}元</div>
          <div
            class="text"
            v-if="detailData.discount>0"
          >订单多收：{{Number(detailData.discount).toFixed(2)}}元</div>
        </div>
        <div class="text_bw">
          <div class="text">
            实收：
            <em style="font-weight:bold">{{detailData.real_price}}</em>元
          </div>
          <div
            class="text"
            v-if="detailData.discounted_price>0"
          >还款优惠：{{detailData.discounted_price}}元</div>
        </div>
        <div class="text_bw" v-if="detailData.need_repayment_amount>0">
          <div class="text">
            未还：
            <em style="font-weight:bold">{{detailData.need_repayment_amount}}</em>元
          </div>
        </div>
        <div class="text_bw">
          <div class="text">收银：{{detailData.user_realname}}</div>
        </div>
        <div class="text_bw" style="font-size:0.28rem">
          <div class="date">订单编号：{{detailData.order_sn}}</div>
        </div>
        <div class="text_bw" style="font-size:0.28rem" v-if="detailData.remarks">
          <div class="text">订单备注：{{detailData.remarks}}</div>
        </div>
        <div class="text_bw">
          <div class="date">结算时间：{{detailData.create_time | toTime}}</div>
        </div>

        <!-- 杨总要求删除商品金额 <div class="text">商品金额：{{detailData.receivables}}元</div> -->
      </div>
      <div class="part part2">
        <div class="title">
          <span>货品明细</span>
          <span></span>
        </div>
        <div class="text" v-for="(item,index) in detailData.goods" :key="index">
          <div class="titles">
            <span class="goods_name">{{item.name}}</span>

            <div class="good_type good_type_0" v-if="item.bale == 3">
              散装
              <!-- <img src="./../../../../assets/img/work/open_order/order/type_sanzhuang.png" alt /> -->
            </div>
            <div v-if="item.bale == 1" class="good_type good_type_1">
              定装
              <!-- <img src="./../../../../assets/img/work/open_order/order/type_dingzhuang.png" alt /> -->
            </div>
            <div class="good_type good_type_2" v-if="item.bale == 2">
              非定装
              <!-- <img
              src="./../../../../assets/img/work/open_order/order/type_feidingzhuang.png" alt/>-->
            </div>
            <div class="good_type good_type_3" v-if=" item.goods_type == 2">附加费</div>

            <div class="item_type">
              <span class="item_type_zy" v-if="item.type == 1 && item.goods_type == 1">自营</span>
              <span class="item_type_dm" v-if="item.type == 2 && item.goods_type == 1">代卖</span>
            </div>

            <span class="total" v-if="item.goods_type == 1 && item.bale == 1">
              小计:
              <em>{{(item.price*item.num).toFixed(2)}}元</em>
            </span>
            <span class="total" v-if="item.goods_type == 1 && item.bale == 2">
              小计:
              <em>{{(item.price*item.weight).toFixed(2)}}元</em>
            </span>
            <span class="total" v-if="item.goods_type == 1 && item.bale == 3">
              小计:
              <em>{{(item.price*item.weight).toFixed(2)}}元</em>
            </span>
            <span class="total" v-if="item.goods_type == 2 && item.type == 1">
              小计:
              <em>{{(item.price*item.num).toFixed(2)}}元</em>
            </span>
            <span class="total" v-if="item.goods_type == 2 && item.type == 2">
              小计:
              <em>{{(item.price*item.num).toFixed(2)}}元</em>
            </span>
          </div>
          <div class="batch_number">
            <div style="font-size:0.28rem">批次：{{item.batch}}</div>
            <div class="van-ellipsis" v-if="item.user_realname">操作员：{{item.user_realname}}</div>
          </div>
          <table class="goods_table" cellspacing="0" border="1" v-if="item.bale == 1">
            <tr>
              <td>规格(公斤/{{unit_list[item.num_unit-1].name}})</td>
              <td>数量({{unit_list[item.num_unit-1].name}})</td>
              <td>单价(元/{{unit_list[item.num_unit-1].name}})</td>
            </tr>
            <tr>
              <td>{{item.bale_num*1}}</td>
              <td>{{item.num*1}}</td>
              <td>{{item.price}}</td>
            </tr>
          </table>
          <table class="goods_table" cellspacing="0" border="1" v-if="item.bale == 2">
            <tr>
              <td>数量({{unit_list[item.num_unit-1].name}})</td>
              <td>重量(公斤)</td>
              <td>单价(元/公斤)</td>
            </tr>
            <tr>
              <td>{{item.num*1}}</td>
              <td>{{item.weight*1}}</td>
              <td>{{item.price}}</td>
            </tr>
          </table>
          <table class="goods_table" cellspacing="0" border="1" v-if="item.bale == 3">
            <tr>
              <td>重量(公斤)</td>
              <td>单价(元/公斤)</td>
            </tr>
            <tr>
              <td>{{item.weight*1}}</td>
              <td>{{item.price}}</td>
            </tr>
          </table>
          <table class="goods_table" cellspacing="0" border="1" v-if="item.goods_type == 2">
            <tr>
              <td>数量(个)</td>
              <td>单价(元/个)</td>
            </tr>
            <tr>
              <td>{{item.num*1}}</td>
              <td>{{item.price}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="part part3">
        <div class="title">
          <span>订单动向</span>
          <span></span>
        </div>
        <van-steps direction="vertical" :active="0" active-color="#666">
          <van-step v-if="detailData.status == 4">
            <div>被改单</div>
            <div style="color:#4D4D4D">操作人员：{{detailData.ouid_realname}}</div>
            <div style="color:#e36209" @click="tobefore(detailData.order_sn,1)">查看改单后</div>
          </van-step>
          <van-step v-if="detailData.status == 3">
            <div>作废</div>
            <div style="color:#4D4D4D">操作人员：{{detailData.ouid_realname}}</div>
            <div style="color:#9A9A9A">{{detailData.update_time | toTime}}</div>
          </van-step>
          <van-step v-if="detailData.annal">
            <div v-for="(item,index) in detailData.annal" :key="index">
              <div>还款</div>
              <div>操作人员：{{item.user_name}}</div>
              <!-- <div>订单金额：{{detailData.amount}}元</div> -->
              <div>赊欠金额：{{item.credit_amount}}元</div>
              <div>还款优惠：{{item.discount_amount}}元</div>
              <div>还款金额：{{item.repayment}}元</div>
              <div>剩余欠款：{{item.need_repayment_amount}}元</div>
              <div v-if="detailData.status && detailData.need_repayment_amount != detailData.order_amount">
                支付方式：
                <span v-if="item.type == 1">现金</span>
                <span v-if="item.type == 2">支付宝</span>
                <span v-if="item.type == 3">微信</span>
                <span v-if="item.type == 4">银行卡</span>
                <span v-if="item.type == 5">POS</span>
              </div>
              <div>{{item.create_time | toTime}}</div>
            </div>
          </van-step>
          <van-step v-if="!detailData.before_sn">
            <div>收银</div>
            <!-- <div style="font-size:0.34rem;line-height:0.5rem;">订单金额：{{detailData.amount}}元</div> -->
            <div>订单金额：{{detailData.amount}}元</div>
            <div>商品金额：{{detailData.receivables}}元</div>
            <div v-if="detailData.discount<0">优惠金额：{{-detailData.discount}}元</div>
            <div v-if="detailData.discount>0">多收金额：{{detailData.discount}}元</div>
            <div>支付金额：{{detailData.payment}}元</div>
            <div>赊欠金额：{{detailData.credit||0}}元</div>
            <div v-if="detailData.status && detailData.need_repayment_amount != detailData.order_amount">
              支付方式：
              <span v-if="detailData.pay_type == 1">现金</span>
              <span v-if="detailData.pay_type == 2">支付宝</span>
              <span v-if="detailData.pay_type == 3">微信</span>
              <span v-if="detailData.pay_type == 4">银行卡</span>
              <span v-if="detailData.pay_type == 5">POS</span>
            </div>
            <div>操作人员：{{detailData.user_realname}}</div>
            <div>{{detailData.create_time | toTime}}</div>
          </van-step>
          <van-step v-if="detailData.before_sn">
            <div>改单</div>
            <div style="font-size:0.34rem;line-height:0.5rem;">订单金额：{{detailData.amount}}元</div>
            <div>商品金额：{{detailData.receivables}}元</div>
            <div v-if="detailData.discount<0">优惠金额：{{-detailData.discount}}元</div>
            <div v-if="detailData.discount>0">多收金额：{{detailData.discount}}元</div>
            <div>支付金额：{{detailData.payment}}元</div>
            <div>赊欠金额：{{detailData.credit||0}}元</div>
            <div v-if="detailData.status && detailData.need_repayment_amount != detailData.order_amount">
              支付方式：
              <span v-if="detailData.pay_type == 1">现金</span>
              <span v-if="detailData.pay_type == 2">支付宝</span>
              <span v-if="detailData.pay_type == 3">微信</span>
              <span v-if="detailData.pay_type == 4">银行卡</span>
              <span v-if="detailData.pay_type == 5">POS</span>
            </div>
            <div>操作人员：{{detailData.user_realname}}</div>
            <div>{{detailData.create_time | toTime}}</div>
            <div style="color:#e36209" @click="tobefore(detailData.before_sn,2)">查看改单前</div>
          </van-step>
        </van-steps>
      </div>
      <template v-if="detailData.status != 3 && detailData.status != 4&&role_type==1">
        <div style="height:1rem"></div>
        <div class="bottom" v-if="(detailData.status != 3 && detailData.status != 4)">
          <span @click="deteleData">作废</span>
          <!-- <span
          :disabled="detailData.before_sn"
          @click="detailData.before_sn?'':changeOrder()"
          >{{detailData.before_sn?'已改单':"改单"}}</span>-->
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getUserData } from "@/api/layout/home";
import { order_list, order_delete, order_print } from "@/api/work/manage/order";
import { timestampToDate, timestampToTime } from "@/utils/timestamp";
export default {
  name: "orderDetail",
  filters: {
    toDate(t) {
      return timestampToDate(t);
    },
    toTime(t) {
      return timestampToTime(t);
    },
    getStatus(key) {
      let status = "";
      key = key + "";
      switch (key) {
        case "1":
          status = "已结清";
          break;
        case "2":
          status = "赊欠";
          break;
        case "3":
          status = "作废";
          break;
        case "4":
          status = "已退款";
          break;
      }
      return status;
    },
  },
  data() {
    return {
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" },
      ],
      listQuery: {
        order_sn: "",
      },
      detailData: {},
      showDetail: true,
      role_type: "",
      printLoading: true,
    };
  },
  created() {
    if (this.$route.query.type == 1) {
      this.listQuery = {
        before_sn: this.$route.query.order_sn,
      };
    } else {
      this.listQuery = {
        order_sn: this.$route.query.order_sn,
      };
    }
    this.$store.dispatch("getAuth").then((res) => {
      if (res.includes(3) || res.includes("3")) {
        this.role_type = 1;
      } else {
        this.role_type = "";
      }
    });
    this.getData();
    this.$navigation.on("back", (to, from) => {
      if (from.route.name == "openOrder_orderPay") {
        this.getData();
      }
    });
  },
  mounted() {},
  methods: {
    // 订单打印
    orderPrint() {
      if (this.printLoading) {
        this.printLoading = false;
        order_print({ order_sn: this.detailData.order_sn })
          .then((res) => {
            this.printLoading = true;
            if (res.code == 200) {
              this.$toast.success(res.message);
            }
          })
          .catch((err) => {
            this.printLoading = true;
          });
      }
    },
    // 获取数据
    getData() {
      order_list(this.listQuery).then((res) => {
        if (res.code == 200) {
          this.detailData = res.data.list[0];
          this.$nextTick(() => {
            this.showDetail = false;
          });
        }
      });
    },
    // 查看改单前
    tobefore(order_sn, type) {
      this.$router.replace({
        path: "/manage/order/orderDetail",
        query: {
          order_sn: order_sn,
          type,
        },
      });
    },

    // 作废
    deteleData() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认作废该订单吗？",
        })
        .then(() => {
          // on confirm
          order_delete({ id: this.detailData.id }).then((res) => {
            if (res.code == 200) {
              this.$toast.success(res.message);
              this.getData();
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 改单
    changeOrder() {
      this.$router.replace({
        path: "/openOrder/changeOrder",
        query: {
          order_sn: this.detailData.order_sn,
          detailData: encodeURI(JSON.stringify(this.detailData)),
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.orderDetail {
  .print_btn {
    position: fixed;
    height: 0.6rem;
    top: 0.14rem;
    z-index: 999;
    right: 0.2rem;
  }
  .gaidan {
    position: fixed;
    height: 0.88rem;
    // line-height: 0.88rem;
    text-align: center;
    right: 0.3rem;
    top: 0;
    z-index: 10;
    font-size: 0.3rem;
    font-weight: 500;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > div {
      padding: 0 0.2rem;
      line-height: 0.54rem;
      border: 0.01rem solid #31b158;
      border-radius: 0.28rem;
      background-color: #31b158;
      color: #fff;
    }
  }
  .part {
    background-color: #fff;
    margin-top: 0.2rem;
    padding: 0 0.3rem;
    font-size: 0.3rem;
    padding-bottom: 0.16rem;
    color: #252525;
    overflow: hidden;
    .title {
      display: flex;
      justify-content: space-between;
      border-bottom: 0.01rem solid #e5e5e5;
      line-height: 0.34rem;
      padding: 0.3rem 0;
      font-size: 0.36rem;
      font-weight: 400;
      margin-bottom: 0.25rem;
      & > span:nth-child(1) {
        padding-left: 0.15rem;
        border-left: 0.05rem solid #31b158;
        em {
          font-size: 0.28rem;
          color: #f3a427;
        }
      }
      > span:last-of-type {
        font-size: 0.32rem;
      }
      .red {
        color: #ff0000;
      }
    }
  }
  .part1 {
    .buyer_name {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.15rem;
      & > span {
        font-weight: bold;
        font-size: 0.36rem;
        line-height: 0.5rem;
      }
      & > span:nth-child(2) {
        color: #31b158;
      }
    }
    .text_bw {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .text {
      line-height: 0.51rem;
    }
    .date {
      color: #9a9a9a;
      font-size: 0.28rem;
      line-height: 0.4rem;
    }
  }
  .part2 {
    .text {
      padding-top: 0.1rem;
      .titles {
        position: relative;
        line-height: 0.52rem;
        display: flex;
        align-items: center;
        .goods_name {
          display: inline-block;
          max-width: 2.2rem;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .good_type {
          margin-left: 0.16rem;
          padding: 0 0.1rem;
          height: 0.4rem;
          line-height: 0.4rem;
          border-radius: 0.2rem;
          display: inline-block;
          font-size: 0.28rem;
          &.good_type_0 {
            background-color: #dafbdb;
            color: #4b9c64;
          }
          &.good_type_1 {
            background-color: #daeffb;
            color: #1d78c5;
          }
          &.good_type_2 {
            background-color: #fbedda;
            color: #bf8535;
          }
          &.good_type_3 {
            background-color: #d1f5fb;
            color: #218b9d;
          }
          img {
            width: 0.22rem;
            height: 0.22rem;
            margin-left: 0.1rem;
          }
        }
        // > span:nth-of-type(2) {
        //   margin-left: 0.2rem;
        //   margin-right: 0.31rem;
        // }
        // > span:not(:first-of-type) {
        //   font-size: 0.24rem;
        //   color: #9a9a9a;
        // }

        & > .total {
          position: absolute;
          right: 0;
          font-size: 0.3rem;
          margin-top: 0.1rem;
          em {
            color: #31b158;
          }
        }
      }
    }
    .batch_number {
      font-size: 0.28rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #999;
      div {
        white-space: nowrap;
      }
      div:nth-child(2) {
        width: 2.4rem;
        text-align: right;
      }
    }
    .goods_table {
      width: 100%;
      font-size: 0.28rem;
      border: 0.01rem solid #e5e5e5;
      margin: 0.1rem 0;
      td {
        width: 33%;
        text-align: center;
        line-height: 0.46rem;
        border: 0.01rem solid #e5e5e5;
      }
    }
    .text:nth-child(2) {
      padding-top: 0;
    }
    .text:not(:last-of-type) {
      border-bottom: 0.01rem solid #f2f2f2;
    }
    .size {
      display: flex;
      justify-content: space-between;
      line-height: 0.48rem;
      flex-wrap: wrap;
      span {
        width: 50%;
      }
    }
    .total {
      line-height: 0.49rem;
      margin-bottom: 0.1rem;
    }

    .item_type {
      display: inline-block;
      font-size: 0.24rem;
      width: 0.7rem;
      text-align: center;
      height: 0.3rem;
      line-height: 0.3rem;
      margin: 0.08rem 0;
      margin-left: 0.2rem;
      span {
        display: inline-block;
        width: 0.7rem;
        text-align: center;
        height: 0.3rem;
        border-radius: 0.06rem;
      }
      .item_type_zy {
        background: rgba(28, 192, 233, 0.3);
        color: #268ea7;
      }
      .item_type_dm {
        background: rgba(233, 153, 28, 0.3);
        color: #c6601c;
      }
    }
  }
  .bottom {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 2;
    box-sizing: border-box;
    > span {
      display: inline-block;
      width: 100%;
      text-align: center;
      font-size: 0.36rem;
      line-height: 1rem;
      &[disabled] {
        background-color: #bbb !important;
      }
    }
    > span:first-child {
      background-color: #fb8a8a;
      color: #fff;
    }
    > span:last-child {
      background-color: #31b158;
      color: #ffffff;
    }
  }
  .item_type_zy {
    background: rgba(28, 192, 233, 0.3);
    color: #268ea7;
  }
  .item_type_dm {
    background: rgba(233, 153, 28, 0.3);
    color: #c6601c;
  }
}
</style>